var React = require('react');

function Target (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M25 44.437c-.628.055-1.264.083-1.906.083-11.834 0-21.427-9.593-21.427-21.426 0-11.834 9.593-21.427 21.427-21.427S44.52 11.26 44.52 23.094c0 .642-.03 1.278-.084 1.907","key":0}),React.createElement("path",{"d":"M23.444 35.199c-.116.003-.234.005-.35.005-6.69 0-12.11-5.422-12.11-12.111 0-6.69 5.42-12.111 12.11-12.111 6.688 0 12.11 5.422 12.11 12.11 0 .118-.002.236-.005.353","key":1}),React.createElement("path",{"d":"M25.889 23.094a2.795 2.795 0 1 1-5.59-.001 2.795 2.795 0 0 1 5.59 0zM48.334 48.335l-18.718-18.72M43.082 30.826l-13.463-1.208 1.096 13.506","key":2})]));
}

Target.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Target;

Target.default = Target;
